
import { Component, Vue } from 'vue-property-decorator';
import { LocationModel } from '@/services/api.service';

import { latLng, LatLng } from 'leaflet';
import {LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import { Location } from 'vue-router';


@Component({
    props: {
        zoomLevel: {
          type: Number,
          required: false,
          default: 13
        },
        autoCenter: {
          type: Boolean,
          required: false,
          default: false
        },
        latitude: {
          type: Number,
          required: true,
          default: 0
        },
        longitude: {
          type: Number,
          required: true,
          default: 0
        }
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup
    }
})
export default class LocationSelectorMap extends Vue {

  private url: string = 'https://{s}.tile.osm.org/{z}/{x}/{y}.png';
  private attribution: string = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
  private zoom: number = 13;
  private center: LatLng = latLng(-37.615669, 144.944433);
  private centerIsDefault: boolean = true;
  private currentZoom: number = 11.5;
  private currentCenter: LatLng = latLng(-37.615669, 144.944433);

  private homeMarker: LatLng = latLng(-37.615669, 144.944433);

  private mounted() {
    // console.log('Supplied locations:');
    // console.log(this.$props.locations);
    // center on the first location
    this.zoom = this.$props.zoomLevel;
    
    
    this.updateLatLng();
    this.centerIsDefault = false;
    
  }

  private zoomUpdate(zoom: number) {
    this.currentZoom = zoom;
  }
  
  private centerUpdate(center: any) {
    this.currentCenter = center;
  }

  private markerLatLngUpdated(newLatLng: LatLng) {
    console.log('Marker location updated', newLatLng);
    this.$emit('location-pin-updated', newLatLng.lat, newLatLng.lng);
  }
  
  private setCenter(newCenter: LatLng) {
    const mapComponent: any = this.$refs.locMap;
    // @ts-ignore
    if (mapComponent !== undefined && mapComponent.mapObject !== undefined) {
      mapComponent.mapObject.setView(newCenter, this.currentZoom);
    }
  }

  private hasLatLng() {
    if (this.$props.latitude === 0 || this.$props.lognitude === 0) {
      // Use the home address
      return false;
    } else {
      return true;
    } 
  }
  private getLatLng(): LatLng {
    // determine the best lat long to use for the location
    // either by the lat long vlaues, or the postcode center point
    
    if (this.$props.latitude === 0 || this.$props.lognitude === 0) {
      // Use the home address
      return this.center;
    } else {
      return latLng(this.$props.latitude, this.$props.longitude);
    } 
  }

  private updateLatLng() {
    // determine the best lat long to use for the location
    // either by the lat long vlaues, or the postcode center point
    if (this.$props.latitude === 0 || this.$props.lognitude === 0) {
      // Use the 
    } else {
      const locLatLng: LatLng = this.getLatLng();
      if (this.$props.autoCenter) {
        this.setCenter(locLatLng);
      }
      if (this.centerIsDefault) {
        // console.log('Updating center point to location and center is null...');
        this.center = locLatLng;
        this.centerIsDefault = false;
      }
    }

  }

}
